<template>
  <div class="help-video-container">
    <TText text="Video Tutorials" font_weight="600" size="24" />
    <div v-for="(video, index) in videos" :key="`video#${index}`" class="help-video-item-container">
      <div class="help-video-item-headline">
        <TText :value="video.title" font_weight="500" size="18" />
        <div class="help-video-item-headline-line" />
      </div>
      <v-responsive>
        <iframe
          :width="height * 16 / 9"
          :height="height"
          :src="video.src"
          :title="video.title"
          frameborder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
          allowfullscreen
        ></iframe>
      </v-responsive>
    </div>
  </div>
</template>

<script>
export default {
  data: () => ({
    height: 600,
    videos: [
      {
        src: "https://www.youtube.com/embed/4aH1U44V2iM",
        title: "Create project"
      },
      {
        src: "https://www.youtube.com/embed/xPbt27hrkdA",
        title: "Invite people to your project"
      },
      {
        src: "https://www.youtube.com/embed/tMHJc_cPzq4",
        title: "Edit project"
      },
      {
        src: "https://www.youtube.com/embed/aJEgrGwIz2g",
        title: "Create a WORK.package"
      },
      {
        src: "https://www.youtube.com/embed/Ski6W81vlOo",
        title: "Add a second train"
      },
      {
        src: "https://www.youtube.com/embed/FtUWvyE3sJ8",
        title: "Create a TAKT.sequence"
      },
      {
        src: "https://www.youtube.com/embed/wB4pqbLXzvo",
        title: "Cloud print"
      }
    ],
  }),
};
</script>

<style>
.help-video-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  grid-gap: 32px;
}
.help-video-item-container {
  display: flex;
  flex-direction: column;
  grid-gap: 8px;
}
.help-video-item-headline {
  display: flex;
  grid-gap: 16px;
  align-items: center;
}
.help-video-item-headline-line {
  border-bottom: 1px solid;
  color: inherit;
  flex: 1 1 0px;
}
</style>
